import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
export function useApproveAmendments() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: errorTexts } = useLocaleKeys('errors');
    const overlayContext = useOverlayContext();
    return async function approveAmendments(param) {
        let { id, version, latestAmendmentVersion, hideSuccessToast, throwOnError, onSuccess } = param;
        const approve = await handleRequest(api.relationship.approveAllAmendments(id, version, latestAmendmentVersion));
        if (!approve.success) {
            const errorMsg = approve.error.hasServerError(ServerError.MismatchingRelationshipVersion) ? errorTexts.mismatchingRelationshipVersion() : approve.error.hasServerError([
                ServerError.InvalidRelationshipStatus,
                ServerError.RelationshipAlreadyTerminated
            ]) ? 'The agreement was terminated' : 'Failed to approve amendments, please try again';
            overlayContext.showErrorToast(errorMsg, 'approve-amendments-error');
            if (throwOnError) throw approve.error;
        } else {
            onSuccess && await onSuccess();
            !hideSuccessToast && overlayContext.showSuccessToast(commonTexts.toasts.approvedAmendmentsSuccessfully(), 'approve-amendments-success');
        }
    };
}
